import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/auth.slice';
import enumsSlice from './slices/enums.slice';

export class StoreKeeper {
  public static store: any;
}

export const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    enums: enumsSlice.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
